
<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
           
        </span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
<div *ngIf="!IsBillingActive">
    <div class="ttmodal__body" >
       
        <h3>A new quote will be generated - Do you wish to continue? </h3>
    </div>
    <div class="ttmodal__footer" style="text-align: right;">
        <button mat-raised-button (click)="onNoClick()">No</button>
        <button mat-raised-button color="warn" (click)="ActiveBillingSection()">
            <span class="button__text">Yes</span>
        </button>
    </div>
</div>
    <!-- <div *ngIf="IsBillingActive">
        <div class="ttmodal__body">
       
            <mat-form-field class="header-form-full-width" >
                <span class="label">Dealer group</span>
                <mat-select id="select-Dealer" placeholder="Select Dealer group" [(ngModel)]="dealerGroupId"
                    (selectionChange)="OndealerGroupSelect()">
                    <mat-option [value]="item.Id" *ngFor="let item of userDealerGroup">
                        {{item.Name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="header-form-full-width">
                <span class="label">Dealership</span>
                <mat-select id="select-customer" placeholder="Select Dealership" [(ngModel)]="dealershipId"
                (selectionChange)="OndealershipSelect()" >
                    <mat-option [value]="item.DealershipId" *ngFor="let item of userDealerGroupDealerships">
                        {{item.DealerShipName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="header-form-full-width">
                <span class="label">Customer</span>
                <mat-select id="select-customer" placeholder="Select Customer" [(ngModel)]="selectedCustomer"
                    >
                    <mat-option [value]="item.customer_auto" *ngFor="let item of dealershipsCustomers">
                        {{item.cust_name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
    
            <mat-form-field class="header-form-full-width">
                <input type="text" matInput name="FirstName" [(ngModel)]="FirstName" #quantity="ngModel" id="firstName"
                placeholder="First Name">
            </mat-form-field>
    
           
            <mat-form-field class="header-form-full-width">
                <input type="text" matInput name="lastName" [(ngModel)]="LastName" #lastName="ngModel" id="lastName"
                    placeholder="Last Name">
            </mat-form-field>
    
    
            <div>
                <mat-form-field class="header-form-full-width">
                  <input class="email-from" matInput placeholder="{{'Email' | translate | async}}" type="text" [(ngModel)]="emailAddress" [formControl]="emailControl"
                required>
                </mat-form-field>
                <div *ngIf="emailControl.errors && (emailControl.dirty || emailControl.touched)" style="margin-bottom: 20px;">
                  <mat-error *ngIf="emailControl.errors.required">{{'Email is required'| translate | async}}</mat-error>
                  <mat-error *ngIf="emailControl.errors.email">{{'Email is invaild'| translate | async}}</mat-error>
                </div>
            </div>
            
            <mat-form-field class="header-form-full-width">
                <input type="number" matInput name="contactNo" [(ngModel)]="ContactNo" #contactNo="ngModel" id="contactNo"
                    placeholder="Contact Number">
            </mat-form-field>
    
            <mat-form-field class="header-form-full-width">
                <textarea matInput placeholder="Delivery Address" [(ngModel)]="DeliveryAddress"></textarea>
            </mat-form-field>
    
            <mat-checkbox class="example-margin" [(ngModel)]="checked"  (change)="changeCheckbox($event)">Billing address same as Delivery Address</mat-checkbox>
    
            <mat-form-field class="header-form-full-width">
                <textarea matInput placeholder="Billing Address" [(ngModel)]="BillingAddress"></textarea>
            </mat-form-field>
            
    
        </div>
        <div class="ttmodal__footer" style="text-align: right;">
            <button mat-raised-button (click)="onNoClick()">Cancel</button>
            <button mat-raised-button color="warn" (click)="SavePartConfiqQuote()">
                <span class="button__text">Save</span>
            </button>
        </div>
    </div> -->
    
</div>